import { useEffect, useState } from 'react'
import {decodetoken } from './cipher.js'
import Main from './component/main.js'
import Healthmonitoring from './component/healthmonitoring.js'
import '@aws-amplify/ui-react/styles.css'
import { Amplify, Auth } from 'aws-amplify';
import aws_exports from './aws-exports';
import { I18n } from "aws-amplify";
import { translations } from '@aws-amplify/ui';
import './App.css'

import zoomPlugin from "chartjs-plugin-zoom";
import {
    Chart as ChartJS,
    ChartConfiguration,
    BarController,
    LineController,
    CategoryScale,
    LinearScale,
    TimeScale,
    LogarithmicScale,
    PointElement,
    LineElement,
    BarElement,
    Title,
    Tooltip,
    Legend,
} from "chart.js";

ChartJS.register(
    LineController,
    BarController,
    CategoryScale,
    LinearScale,
    TimeScale,
    LogarithmicScale,
    BarElement,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend,
    zoomPlugin
);

Amplify.configure(aws_exports);
I18n.putVocabularies(translations);
I18n.setLanguage('ja');

let logoutCheckCache = null;
let tokenSigninCache = null;

function App({ signOut, user }) {
  const [code, setcode] = useState("");
  const [date, setdate] = useState("");
  const [name, setname] = useState("");
  
  async function signin(loginid, password) {
    try {
      const user = await Auth.currentSession()
      var id = user.getIdToken()["payload"]["cognito:username"]
      if (id == loginid) {
        return false;
      }
      await Auth.signOut();
    } catch (err) {}

    await Auth.signIn(loginid, password);
    window.location.reload();
    return true;
  }

  async function tokensignin(token) {
    var value = JSON.parse(await decodetoken(token));
    if ( new Date(value[3]).getTime()+60*60*24*1000*7 > Date.now() ) {
      var reloading = await signin(value[0], value[1]);
      if (reloading) {
        return false;
      }
      setcode(value[2]);
      setdate(value[3]);
      setname(value[4]);
    }
    return true;
  }

  async function logoutifnecessary() {
    try {
      const user = await Auth.currentSession()
      var id = user.getIdToken()["payload"]["cognito:username"]
      if (id == "healthmonitor") {
        await Auth.signOut();
      }
    } catch(err) {}
  }

  //地震時のトークンログイン
  const url = new URL(window.location.href);
  const token = url.searchParams.get('token');
  //サイネージ用ログイン
  const fragment = window.location.hash.substring(1); // "id=xxx&pw=yyy" など
  const params = new URLSearchParams(fragment);
  const id = params.get('id');
  const pw = params.get('pw');
  const site = params.get('site');
  const [tokenChecked, setTokenChecked] = useState(token == null);
  const normalAccess = token == null && !(id && pw && site);
  var mode = "";

  useEffect(() => {
    if (!normalAccess) {
      return;
    }

    const cacheKey = window.location.href;
    if (!logoutCheckCache || logoutCheckCache.key !== cacheKey) {
      const promise = logoutifnecessary();
      logoutCheckCache = { key: cacheKey, promise };
      promise.finally(() => {
        setTimeout(() => {
          if (logoutCheckCache && logoutCheckCache.promise === promise) {
            logoutCheckCache = null;
          }
        }, 0);
      });
    }
  }, [normalAccess]);

  useEffect(() => {
    if (token == null) {
      setTokenChecked(true);
      return;
    }

    setTokenChecked(false);

    const cacheKey = token;
    if (!tokenSigninCache || tokenSigninCache.key !== cacheKey) {
      const promise = tokensignin(token);
      tokenSigninCache = { key: cacheKey, promise };
      promise.finally(() => {
        setTimeout(() => {
          if (tokenSigninCache && tokenSigninCache.promise === promise) {
            tokenSigninCache = null;
          }
        }, 0);
      });
    }

    tokenSigninCache.promise.then((checked) => {
      if (checked) {
        setTokenChecked(true);
      }
    }).catch(() => {
      setTokenChecked(true);
    });
  }, [token]);

  if (id && pw && site) {
    signin(id, pw);
    mode = site;
  }
  return (
    <>
      { token===null ? <Main site={mode}/> : !tokenChecked ? null : code === "" ? <>不正なアクセスです<br/>※URLの有効期間は7日間です</> : <><h2>{name}</h2><Healthmonitoring point={{sensors:{earthquake:[{id:code}]}}} datetime={date}/></>}
    </>
  )
}

export default App;
